import type { FaireProductEntity } from "../../entity_types/product";

export const p_ac0uxwjy57: FaireProductEntity = {
  token: "p_ac0uxwjy57",
  type: "product",
  name: "Basic Building Blocks 102 Piece XL Wooden Starter Set",
  brandToken: "b_81kagp61wy",
  brandName: "HABA USA",
  imageUrl:
    "https://cdn.faire.com/fastly/2a378d8db0b9089cd1ff08441809ee0fe55c9c0530b12214648bff580ca67cf2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6f4fe518ca5cca049f5796cc76e963a2e0cfe595d61d37f7d9f0a3c68a0a0fba.jpeg",
    "https://cdn.faire.com/fastly/95b9f98e8646faad082337c4a181d5623da9f5dc3c26627aac3bb7dc567cf155.jpeg",
    "https://cdn.faire.com/fastly/72e2de2ef602a336e8ebb12ed899ed5a322303bacac3d473ea0013a8754007dd.jpeg",
    "https://cdn.faire.com/fastly/1e57d2e845c60105f378cf7458682ada49a6ba424de47d7de37ba47f3034a733.jpeg",
    "https://cdn.faire.com/fastly/08dbab36ee6c032daaf02fe4bbe0c57e52e9657ca5a3f25e3c2093451c1a5dd9.jpeg",
    "https://cdn.faire.com/fastly/2cbfcd2b3412ef3d081db695fe3c689f70fd71fa6142d4d3d18b9d817ef41da9.jpeg",
    "https://cdn.faire.com/fastly/4c75eda9fa06c8a5e9ecf815c16e8367ee27bcb825b4e1313d6eef92e711c805.jpeg",
    "https://cdn.faire.com/fastly/a2bef2dfc6e278edac3be7624fecd575a40b191d9fd1ea8c4936486b34df3c9a.jpeg",
  ],
  priceDollars: 100,
  description:
    "Go Big with HABA USA’s Large Wooden Building Blocks\n\nIs your little one ready to unleash her inner builder? Our large building blocks are just what the construction team ordered. These classic wooden blocks are perfect for building your child’s engineering skills early on while also honing their hand-eye coordination and fine motor skills. Plus, you can keep them occupied for hours on end. They’re the perfect toy for letting your child’s imagination and growth run wild like never before!\n\n * Recommended for ages 1 year+ \n * 102 pieces included \n * Made in Germany using reforested, untreated beech wood \n * Shapes come in standard measurements (1.75” x 1.75”) \n * Compatible with all other building block systems \n * Receive 20 FREE clamps with your purchase \n * PEFC certified for sustainable forestry \nStart Building Something Bigger\n\nNo matter your child’s age, they’ll get a kick out of creating something that is all their own. Make it easy for them with this extra-large building block set from HABA USA. These blocks are proven to foster healthy imaginations and assist children in spatial reasoning.",
  tags: [],
  msrpDollars: 200,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:59.711Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
